import { AxiosInstance } from "axios";
import { UUID } from "crypto";

import { UserStats } from "@/lib/types/User";

export enum UsagePurpose {
  Business = "Business",
  NGO = "NGO",
  Personal = "Personal",
  Student = "Student",
  Teacher = "Teacher",
}

export type UserIdentityUpdatableProperties = {
  onboarded: boolean;
  usage_purpose?: UsagePurpose;
};

export type UserIdentity = {
  id: UUID;
  email?: string;
  onboarded: boolean;
  usage_purpose?: string;
  organisation_id?: UUID;
  role?: string;
  active?: boolean;
};

export const getUserIdentity = async (
  axiosInstance: AxiosInstance,
): Promise<UserIdentity> => {
  const { data } = await axiosInstance.get<UserIdentity>(`/user/identity`);

  return data;
};

export const getUser = async (
  axiosInstance: AxiosInstance,
): Promise<UserStats> => (await axiosInstance.get<UserStats>("/user")).data;
